import { NgModule } from '@angular/core';
import { FiElementFocusedDirective } from './fi-element-focused.directive';

@NgModule({
    declarations: [FiElementFocusedDirective],
    exports: [FiElementFocusedDirective],
})
export class FiElementFocusedModule {}
